import * as Sentry from '@sentry/react';
import { Amplify } from 'aws-amplify';
import { PostHogProvider } from 'posthog-js/react';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from '@/app';

import { config } from './config';
import { amplifyConfig } from './config/amplify';
import { createPostHogOptions } from './telemetry/posthog-options';

Amplify.configure(amplifyConfig);

Sentry.init({
  dsn: config.VITE_SENTRY_DSN,
  enabled: window.location.hostname !== 'localhost',
  environment: config.MODE,
  release: `${config.MODE}-${config.VITE_COMMIT_SHA_SHORT}`,
  denyUrls: [/^chrome-extension:\/\//i, /^moz-extension:\/\//i, /^safari-extension:\/\//i],
  ignoreErrors: [
    // Document signing embed SDK (post-me library) throws this when the iframe sends an
    // unknown postMessage method. Not actionable from our side.
    'Error invoking post: Method not found',
  ],
});

const posthogOptions = createPostHogOptions({
  apiHost: config.posthog.apiHost,
  development: config.IS_DEVELOPMENT,
});

ReactDOM.createRoot(document.getElementById('root')!, {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),
  onCaughtError: Sentry.reactErrorHandler(),
}).render(
  <React.StrictMode>
    <PostHogProvider apiKey={config.posthog.apiKey} options={posthogOptions}>
      <App />
    </PostHogProvider>
  </React.StrictMode>,
);
